import { IWorkflow } from "@/interfaces/workflow.interface";
import { WorkflowMessages } from "@/messages/workflow/workflow.messages"; // Importe as mensagens corretas para workflows
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";
import { WorkflowTypes } from "@/types/workflow.types";

import { WorkflowFilterKey } from "./types";

export const WORKFLOWS_TABLE_COLUMNS = (messages: WorkflowMessages) => [
  messages.nameColumn,
  messages.triggerColumn,
  messages.descriptionColumn,
  messages.statusColumn,
  messages.optionsColumn,
];

export const FILTER_OPTIONS = (messages: WorkflowMessages): SelectData<WorkflowFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.statusOption, value: "active" },
  { label: messages.titleOption, value: "name" },
  { label: messages.descriptionOption, value: "description" },
  { label: messages.workflowTypeOption, value: "workflowTypeId" },
];

export const WORKFLOW_TYPE_OPTIONS = (messages: WorkflowMessages): SelectData<number>[] => [
  { label: messages.startFlow, value: WorkflowTypes.StartFlow },
  { label: messages.orderStatus, value: WorkflowTypes.OrderStatus },
  { label: messages.shopping, value: WorkflowTypes.Shopping },
];

export const STATUS_OPTIONS = (messages: WorkflowMessages): SelectData<boolean>[] => [
  { label: messages.statusTrueOption, value: true },
  { label: messages.statusFalseOption, value: false },
];

export const FILTER_ATTRIBUTES: Partial<Record<WorkflowFilterKey, FilterAttributes>> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  description: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  active: {
    defaultValue: true,
    type: FilterType.Equals,
    valueType: "boolean",
  },
  name: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
  workflowTypeId: {
    defaultValue: 1,
    type: FilterType.Equals,
    valueType: "options",
  },
};

export const FILTER_OPTION_VALUES = (
  messages: WorkflowMessages
): Partial<Record<WorkflowFilterKey, SelectData<FilterValue>[]>> => ({
  active: STATUS_OPTIONS(messages),
  workflowTypeId: WORKFLOW_TYPE_OPTIONS(messages),
});

export const initialFilterValues: IFilter<IWorkflow>[] = [
  {
    property: "name",
    value: "",
    filterType: FilterType.Contains,
  },
];
